export const es = {
    defaultTitle: `Resultado de la acción`,
    processingTitle: `Procesando...`,
    processingDescription: `Por favor espera mientras procesamos tu solicitud`,
    success: `Acción completada con éxito`,
    error: `Ocurrió un error`,
    unexpectedError: `Ocurrió un error inesperado. Por favor inténtalo de nuevo.`,
    serverUnavailable: `El servidor no está disponible. Por favor inténtalo más tarde.`,
    networkUnavailable: `No se puede conectar al servidor. Por favor verifica tu conexión a internet.`,
    redirect: `Redirigiendo en {count} segundos...`,
    continueNow: `Continuar ahora`,
};
//# sourceMappingURL=es.js.map